export enum Timer {
    MIN5 = 5,
    MIN10 = 10,
    MIN15 = 15,
    MIN30 = 30,
    H1 = 60,
    H6 = 360,
    H12 = 720
}